import React, { useState } from "react";

import DescriptionBox from "pages/details/components/description-box";
import DetailList from "pages/details/components/detail-list";
import TagsList from "pages/details/components/tags-list";
import MediaGallery from "pages/details/components/media-gallery";
import { useParams } from "react-router-dom";
import { useAddonDetails } from "hooks/useAddonDetails";
import AddonHeader from "./components/addon-header";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";

function AddonDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { addon, isLoading } = useAddonDetails(id);

  return (
    <div className="addonDetails">
      {isLoading ? (
        <div className="my-center">
          <Spinner animation="grow" variant="primary" />
        </div>
      ) : (
        <>
          <AddonHeader
            addonId={id}
            isInWishlist={addon?.isInWishlist}
            logo={addon?.logo}
            title={addon?.title}
            label={addon?.addonLabel}
            price={addon?.addonPrice}
            purchasedVersions={addon?.purchasedVersions}
          />
          <div className="row">
            <div className="col-xl-6">
              <div className="all-content">
                <DescriptionBox content={addon?.description} />
                <DetailList
                  items={addon?.availableAppVersions ?? []}
                  title={t("details:addonDetails.availableVersions")}
                  labelField="title"
                />
                <TagsList tags={addon?.tags ?? []} />
              </div>
            </div>
            <div className="col-xl-6">
              <MediaGallery
                images={
                  addon?.slidersPath?.map((slider) => ({
                    original: slider,
                    thumbnail: slider
                  })) ?? []
                }
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AddonDetailPage;
